export enum InventoryStatus {
    InNetwork = 2,
    SpecialItem = 3,
    Stocked = 5,
    Available = 6,
    ContactBranchForAvailability = 7
}